import { PUBLIC_STATION_CHARGING_SUMMARY } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  publicStationChargingSummaries: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const publicStationChargingSummaryReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PUBLIC_STATION_CHARGING_SUMMARY.REQUEST: {
      return { ...state, isLoading: true };
    }
    case PUBLIC_STATION_CHARGING_SUMMARY.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        publicStationChargingSummaries: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case PUBLIC_STATION_CHARGING_SUMMARY.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default publicStationChargingSummaryReducer;
